import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./globalSlice";

const globalStore = configureStore({
    reducer: {
        global: globalReducer
    }
})

export default globalStore;